import {Logger} from '../utilities/logger';
import {A11yConsentApi} from '../a11y-consent-api';
import mitt, {Emitter} from 'mitt';

/**
 * Base for a component.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export abstract class AbstractComponent {
  // Emits events related to the component
  public readonly emitter: Emitter<any> = mitt<any>();

  // A11y Consent API
  public readonly api: A11yConsentApi;

  // Container of the component
  public readonly container: HTMLElement;

  /**
   * @param {A11yConsentApi} api A11y Consent API
   * @param {HTMLElement} container Main container of the component
   */
  protected constructor(api: A11yConsentApi, container: HTMLElement) {
    Logger.debug('component', 'Starting to construct.');
    this.container = container;
    this.api = api;
    Logger.debug('component', 'Finished constructing.');
  }
}
